import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CommonModule as NimbusCommonModule } from '../common/common.module';

import { SocialWidgetComponent } from './social-widget.component';
import { ShortUrlComponent } from './short-url.component';
import { SocialService } from './social.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NimbusCommonModule
  ],
  declarations: [
    SocialWidgetComponent,
    ShortUrlComponent
  ],
  exports: [
    SocialWidgetComponent
  ],
  providers: [
    SocialService
  ]
})
export class SocialModule { }
